/**
 * @description Retrieves all the personnel sync history
 */

import React from 'react';

import { ToastContext } from '@seccon/core/contexts/toast';
import decodeJson from '@seccon/shared/utils/decodeJson';

/**
 * @returns {{ data: object[], error: boolean}} - the data array of historical sync results and the error state
 */
const useSyncHistory = () => {
  const toastApi = React.useContext(ToastContext);

  // Maintains the sync history state
  const [data, setData] = React.useState(null);

  // Maintains the error state of the fetch
  const [error, setError] = React.useState(false);

  /**
   * Handles fetch success by storing the response in the history state
   * @param {object | object[]} response - api response
   */
  function handleSuccess (response) {
    setData(response ?? []);
  }

  /**
   * Handles fetch failures by notifying the user
   */
  function handleFailure () {
    toastApi.error('Personnel Sync history could not be retrieved. Reload the page and try again');

    setError(true);
  }

  /**
   * On mount, fetches a list of historical sync results
   */
  React.useEffect(() => {
    // If the historys state is already defined, exit
    if (data !== null) {
      return;
    }

    fetch('/personnelSyncHistory')
      .then(decodeJson)
      .then(handleSuccess)
      .catch(handleFailure)
  }, []);

  return { data, error };
}

export default useSyncHistory;
